<template>
  <div class="choose-monthly-deposit">
    <div class="r-text-intro">תמיד אפשר לשנות, אז...</div>
    <div class="r-text-headline-paragraph">
      <div>מה דעתך להתחיל עם הפקדה </div>
      <div>
        <span>של </span>
        <span class="r-text-bold">{{ formatAmount(monthlyDepositSum) }} ₪</span>
        <span> בחודש?</span>
      </div>
    </div>

    <div class="r-form">
      <div class="r-form-row">
        <default-slider
          class="slider"
          :label-value="`${ formatAmount(monthlyDepositSum) } ₪`"
          :value="monthlyDepositSum"
          :min="100"
          :step="50"
          :max="2000"
          @input="setMonthlyDepositSum" />
      </div>
    </div>

    <default-button label="הבא >" @click="nextPage" :disable="locked" :loading="locked"/>

    <div v-if="!hasCashflowProduct" class="r-text-regular" style="margin-top: 36px">
      <div class="text-pre">דרך אגב, עם רייזאפ יהיה לך קל לדעת כשאפשר
      להגדיל את ההפקדה החודשית ולעשות את זה
      בקלות בכמה קליקים.
      </div>
      <div class="r-benefit" style="margin-top: 16px">מחכה לך בסוף ההרשמה הטבה לחודשיים</div>
      <div class="r-benefit" >חינם ברייזאפ ללא התחייבות 🎁</div>

    </div>
  </div>
</template>

<script>
import WizardPage from '@/mixins/WizardPage';
import { mapGetters, mapMutations, mapState } from 'vuex';
import DefaultButton from '@/components/styled/DefaultButton';
import DefaultSlider from '@/components/styled/DefaultSlider';
import MoneyFormat from '@/mixins/MoneyFormat';

export default {
  name: 'ChooseMonthlyDeposit',
  components: { DefaultSlider, DefaultButton },
  mixins: [WizardPage, MoneyFormat],
  computed: {
    ...mapState('meitavDash/openFund', ['monthlyDepositSum']),
    ...mapGetters('session', ['hasCashflowProduct']),
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setMonthlyDepositSum']),

  },
};
</script>

<style lang="scss" scoped>
.slider {
  margin: 40px 0 72px 0;
}

.text-pre {
  white-space: break-spaces;
}

</style>
